import {Attribute, Directive, forwardRef} from "@angular/core";
import {AbstractControl, NG_VALIDATORS, Validator} from "@angular/forms";
import {Stock} from "../../../shared/view-model/stock";

export const STOCK_ITEM_EXISTS_IN_DEPOT_ERROR = 'stockItemAlreadyExists';

export function validateStockInDepotFactory(stocksInDepot: Stock[]) {
  return (c: AbstractControl) => {
    let stockItemCuid = c.value;

    // Stock item already exists
    if (stockItemCuid && stocksInDepot.find(s => s.stock_item.cuid == stockItemCuid)) {
      console.warn("Stock item #" + c.value + " already exists in depot");

      let err = {};
      err[STOCK_ITEM_EXISTS_IN_DEPOT_ERROR] = true;
      return err;

    }

    return null;
  };
}

@Directive({
  selector: '[vbValidateStockItemNotExists][formControlName],[vbValidateStockItemNotExists][formControl],[vbValidateStockItemNotExists][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateStockItemNotExistsDirective), multi: true}
  ]
})
export class ValidateStockItemNotExistsDirective implements Validator {

  validator: Function;

  constructor(@Attribute('vbValidateStockItemNotExists') public stocksInDepot: Stock[]) {
    this.validator = validateStockInDepotFactory(stocksInDepot);
  }

  validate(c: AbstractControl): {[key: string]: any} {
    return this.validator(c);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/add-stocks-table-view/validate-stock-item-not-exists.directive.ts